module.exports = __webpack_public_path__ + "static/img/dcqz.8e8c600.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header1/img/dcqz.png
// module id = 305
// module chunks = 40 41 42